export default "__VITE_ASSET__DXzHWa40__"